export default "__VITE_ASSET__BztPI_Aq__"